"use client";

import { Layout30 } from "@/components/layouts/layout-30";
import { getLayout30Menus } from "@/config/layout-30-navigation";
import { useWorkspaceContext } from "./workspace-context";
import { WorkspaceState } from "./workspace-state";
import { WorkspaceOperationNotices } from "./workspace-operation-notices";
import { WorkspaceEvents } from "@/components/events/event-providers";

function initials(value: string) {
  return value
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export function WorkspaceShell({ children }: { children: React.ReactNode }) {
  const state = useWorkspaceContext();
  if (state.status !== "ready" || !state.context)
    return (
      <WorkspaceState
        status={state.status === "ready" ? "notFound" : state.status}
        reload={state.reload}
      />
    );
  const menus = getLayout30Menus("workspace", state.context.permissions);
  return (
    <Layout30
      settings={{
        audience: "workspace",
        primaryMenu: menus.primary,
        sectionMenu: menus.sections,
        identity: {
          organization: state.context.tenantName,
          workspace: state.context.tenantName,
          initials: initials(state.context.tenantName),
          email: state.context.accountEmail,
        },
      }}
    >
      <WorkspaceOperationNotices />
      <WorkspaceEvents>{children}</WorkspaceEvents>
    </Layout30>
  );
}
